import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlingService {
  private errorSubject = new Subject<{ statusCode: number, errorMessage: string }>();
  error$ = this.errorSubject.asObservable();

  notifyError(statusCode: number, errorMessage: string) {
    this.errorSubject.next({ statusCode, errorMessage });
  }
}
